import React from 'react';
import { Box, Icon, useRecipe } from '@chakra-ui/react';
import { LuCheck } from 'react-icons/lu';

export interface CheckboxCircleProps {
  isSelected: boolean;
}

export const CheckboxCircle: React.FC<CheckboxCircleProps> = ({ isSelected }) => {
  const recipe = useRecipe({ key: 'checkboxCircle' });
  const styles = recipe({ isSelected });

  return (
    <Box css={styles}>
      {isSelected && <Icon as={LuCheck} boxSize={5} />}
    </Box>
  );
};


